import { createReducer, on } from '@ngrx/store';
import { storeEquipmentData, clearEquipmentData, getEquipmentData } from './equipment.actions';
import { EquipmentState } from './equipment.model'; 
import { useLocalStorage } from '../../utilities/browser/localStorage.utilities';

const { getItem, setItem, removeItem } = useLocalStorage();

const getDefaultState = (): EquipmentState => ({
  equipment: {
    details: {
      id: '',
      make: '',
      model: '',
      serialNumberRange: '',
      pvc: '',
      equipmentCode: ''
    },
    resources: [],
    prompts: []
  }
});

const loadInitialState = (): EquipmentState => {
  const storedEquipment = getItem('equipment');
  return storedEquipment ? JSON.parse(storedEquipment) : getDefaultState();
};

export const initialState: EquipmentState = loadInitialState();

export const equipmentReducer = createReducer(
  initialState,
  on(storeEquipmentData, (state, { equipment }) => {
    const updatedState = {
      ...state,
      equipment: {
        ...state.equipment,
        ...equipment
      }
    };
    setItem('equipment', JSON.stringify(updatedState));
    return updatedState;
  }),
  on(clearEquipmentData, () => {
    const clearedState = getDefaultState();
    removeItem('equipment');
    return clearedState;
  }),
  on(getEquipmentData, () => {
    return loadInitialState();
  }),
);
